import type { GigListing } from "../../api/gigboard";
import { Banner } from "../../components/Banner";
import { Button, buttonClass } from "../../components/Button";
import { safeHref } from "../../lib/format";
import { GigModal, ModalKicker, ModalTitle } from "./GigModal";

/* Apply: we can't see the application itself, so the click is the signal. A short "leaving" step sets expectations. */
export function ApplyModal({
  listing,
  onContinue,
  onClose,
}: {
  listing: GigListing;
  /** Called as the listing opens in a new tab. */
  onContinue: () => void;
  onClose: () => void;
}) {
  const url = safeHref(listing.url);
  const action = listing.direct ? "Apply now" : `Apply on ${listing.source}`;
  return (
    <GigModal label={action} onClose={onClose}>
      <ModalKicker>Leaving to apply</ModalKicker>
      <ModalTitle>{action}</ModalTitle>
      <p className="my-3">
        <b>{listing.title}</b>
        <br />
        <span className="text-[13px] text-text-muted">{listing.company}</span>
      </p>
      <Banner tone="note">
        <b>Before you apply:</b> use your Step 3 structure. Greet the client by name, name their
        need, link your portfolio, give your plan and price, and end with a question.
      </Banner>
      <p className="text-[13px] text-text-muted">
        We'll save this to My applications. On Friday we'll ask how it went.
      </p>
      <div className="mt-3 flex flex-wrap gap-2.5">
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener"
            onClick={() => {
              onContinue();
              onClose();
            }}
            className={buttonClass("primary")}
          >
            {listing.direct ? "Continue to apply" : `Continue to ${listing.source}`} ↗
          </a>
        ) : (
          <Banner tone="bad">This listing's link doesn't work. Pick another gig.</Banner>
        )}
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </GigModal>
  );
}
